import React from 'react';
import { Controller } from 'react-hook-form';
import { CombinedSkillsInput } from './CombinedSkillsInput';

const transformToOptions = (items) =>
  Array.isArray(items)
    ? items.map((item) => ({
        value: item.id.toString(),
        label: item.name,
        abbreviation: item.abbreviation || item.short_name,
        category: item.category || item.category_name,
      }))
    : [];

export function SkillsSection({ control, masterData, watch }) {
  const skillOptions = React.useMemo(
    () => transformToOptions(masterData?.skills),
    [masterData?.skills]
  );

  const currentSkills = watch?.('skills') || [];

  const defaultSkills = React.useMemo(
    () => (Array.isArray(currentSkills) ? currentSkills : []),
    [currentSkills]
  );

  return (
    <div>
      <Controller
        name="skills"
        control={control}
        defaultValue={defaultSkills}
        render={({ field: { onChange, value: skillsValue = [] } }) => (
          <CombinedSkillsInput
            options={skillOptions}
            value={{ skills: skillsValue }}
            onChange={(combinedValue) => onChange(combinedValue.skills)}
            placeholder="Search skills..."
            className="text-xs"
          />
        )}
      />
    </div>
  );
}
